import React, { useEffect, useState } from "react";
import { getAwardRanking } from "../api/applicationsService.js";
import { TOTAL_MAX } from "../data/mockData";
import { Badge } from "../components/common";

export default function AwardPage() {
  const [apps, setApps] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);

  const ITEMS_PER_PAGE = 15;

  const totalPages = Math.ceil(apps.length / ITEMS_PER_PAGE);

  const startIndex = (currentPage - 1) * ITEMS_PER_PAGE;
  const endIndex = startIndex + ITEMS_PER_PAGE;

  const paginatedApps = apps.slice(startIndex, endIndex);

  useEffect(() => {
    loadRanking();
  }, []);

  const loadRanking = async () => {
    try {
      const data = await getAwardRanking();
      setApps(data);
    } catch (err) {
      console.error("Failed to load award ranking", err);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <div className="p-5">Loading...</div>;
  }

  return (
    <div className="p-4 sm:p-7">
      <div className="flex justify-between items-end flex-wrap gap-3 mb-5">
        <div>
          <h1
            className="text-2xl font-normal mb-1"
            style={{ fontFamily: "serif" }}
          >
            पुरस्कार निवड व श्रेणीक्रम
          </h1>
          <p className="text-sm text-slate-500">
            गुणांनुसार स्वयंचलित श्रेणीक्रम — समिती अंतिम मान्यतेच्या प्रतीक्षेत
          </p>
        </div>

        {/* <button className="w-full sm:w-auto bg-amber-400 hover:bg-amber-500 text-slate-900 font-bold text-xs px-4 py-2.5 rounded-lg">
          🏆 अंतिम यादी तयार करा
        </button> */}
      </div>

      <div className="bg-white border border-slate-200 rounded-xl overflow-x-auto">
        <table className="w-full text-xs border-collapse min-w-[860px]">
          <thead>
            <tr style={{ background: "#0e2a47" }} className="text-slate-100">
              {[
                "श्रेणी",
                "अर्ज क्र.",
                "नाव",
                "तालुका",
                "पदनाम",
                "प्रकार",
                "एकूण गुण",
                "पुरस्कार स्थिती",
              ].map((h) => (
                <th key={h} className="text-left px-3 py-2.5 font-semibold">
                  {h}
                </th>
              ))}
            </tr>
          </thead>

          <tbody>
            {paginatedApps.map((a) => (
              <tr key={a.applicationId} className="border-b border-slate-100">
                <td className="px-3 py-2.5 font-mono">
                  {a.rank}
                </td>

                <td className="px-3 py-2.5 font-mono font-semibold">
                  {a.applicationNumber}
                </td>

                <td className="px-3 py-2.5">
                  {a.teacherName}
                </td>

                <td className="px-3 py-2.5">
                  {a.taluka}
                </td>

                <td className="px-3 py-2.5">
                  {a.pad || "-"}
                </td>

                <td className="px-3 py-2.5">
                  <span
                    className={`px-2.5 py-0.5 rounded-full text-[11px] font-bold whitespace-nowrap ${a.workType === "विशेष कार्य"
                      ? "bg-purple-100 text-purple-700"
                      : "bg-slate-100 text-slate-600"
                      }`}
                  >
                    {a.workType || "-"}
                  </span>
                </td>

                <td className="px-3 py-2.5 font-mono">
                  {(a.reviewedTotalMarks)} / {a.totalMarks}
                </td>

                <td className="px-3 py-2.5">
                  {a.rank <= 5 ? (
                    <Badge status="मंजूर" />
                  ) : a.rank <= 10 ? (
                    <Badge status="प्रलंबित" />
                  ) : (
                    <Badge status="पडताळणी पूर्ण" />
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        <div className="flex flex-col sm:flex-row justify-between items-center gap-3 px-4 py-3 border-t border-slate-200">
          <div className="text-sm text-slate-600">
            Showing {startIndex + 1} -{" "}
            {Math.min(endIndex, apps.length)} of {apps.length}
          </div>

          <div className="flex items-center gap-2">
            <button
              onClick={() => setCurrentPage((p) => Math.max(1, p - 1))}
              disabled={currentPage === 1}
              className="px-3 py-1.5 border rounded disabled:opacity-50 disabled:cursor-not-allowed hover:bg-slate-100"
            >
              Previous
            </button>

            {Array.from({ length: totalPages }, (_, i) => (
              <button
                key={i + 1}
                onClick={() => setCurrentPage(i + 1)}
                className={`w-9 h-9 rounded ${currentPage === i + 1
                    ? "bg-blue-900 text-white"
                    : "border hover:bg-slate-100"
                  }`}
              >
                {i + 1}
              </button>
            ))}

            <button
              onClick={() =>
                setCurrentPage((p) => Math.min(totalPages, p + 1))
              }
              disabled={currentPage === totalPages}
              className="px-3 py-1.5 border rounded disabled:opacity-50 disabled:cursor-not-allowed hover:bg-slate-100"
            >
              Next
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}